import React from 'react'
import PropTypes from 'prop-types'
import { CloseIcon } from '@ow/icons'
import { StyledHeader, StyledTitle, StyleIcon } from './styled/content'

export default function Header({ title, onClose }) {
  if (typeof title === 'string') {
    return (
      <StyledHeader>
        <StyledTitle>{title}</StyledTitle>
        <StyleIcon onClick={onClose}>
          <CloseIcon width={18} height={18} fill="rgb(var(--ow-text-color))" />
        </StyleIcon>
      </StyledHeader>
    )
  }
  return title
}

Header.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onClose: PropTypes.func,
}
Header.defaultProps = {
  title: undefined,
  onClose: null,
}
